/**
 * @enum {number}
 */
export const DeliveryPickupType = Object.freeze({
  /** 0: 在外碰面 */
  MeetOutside: 0,
  /** 1: 放在門口 */
  PutOnDoor: 1,
  /** 2: 在門口碰面 */
  MeetInside: 2,
})
